/* eslint-disable max-len */
import React from 'react';
import StyledButton from '../../../../components/StyledButton';
import Cancelicon from '../../../../svgs/Cancelicon';
import Styles from './SelectedRolesAlert.module.scss';

interface ISelectedRolesAlert{
  count:number;
  isShowActivateBtn:boolean;
  isShowDeactivateBtn:boolean;
  onAction:any;
  submitLoaderType?:string;
  loader?:boolean;
}
const SelectedRolesAlert = ({
  count, isShowActivateBtn, isShowDeactivateBtn, onAction,
}:ISelectedRolesAlert) => (
  <div className={Styles.wrapper}>
    <div className={Styles.wrapper__container}>
      <div className={Styles.wrapper__countAndBtns}>
        <div className={Styles.wrapper__count}>
          Selected Role (
          {count || 0}
          )
        </div>
        <div className={Styles.wrapper__btns}>
          {
            isShowDeactivateBtn && (
              <div className={Styles.wrapper__deactivateBtn}>
                <StyledButton name="Deactivate Roles" padding="8px 16px" borderRadius="4px" border="1px solid rgba(205, 213, 225, 1)" backgroundColor="white" fontSize="12px" fontWeight="600" onClick={() => onAction('activate')} />
              </div>
            )
          }

          {
            isShowActivateBtn && (
              <div className={Styles.wrapper__activateBtn}>
                <StyledButton name="Activate Roles" padding="8px 16px" color="white" borderRadius="4px" border="1px solid rgba(76, 205, 120, 1)" backgroundColor="rgba(76, 205, 120, 1)" fontSize="12px" fontWeight="600" onClick={() => onAction('deactivate')} />
              </div>
            )
          }

        </div>
      </div>
      <div className={Styles.wrapper__cancelContainer}>
        <div className={Styles.wrapper__cancelCircle} onClick={() => onAction('cancel')}><Cancelicon color="rgba(18, 18, 18, 1)" /></div>
      </div>
    </div>
  </div>
);

export default SelectedRolesAlert;
